<div class="beamWrapper">
  <h1 class="app-title">IntelliJ-RON</h1>
  <h1 class="app-title second">(Rusty Object Notation)</h1>

  <button vx-button="flat" color="dark" class="download" (click)="goToPlugin()">Get the Plugin</button>

  <a href="https://github.com/vultix/intellij-ron-plugin" vx-button="stroked" color="dark" class="mTop15">
    <fa-icon [icon]="['fab', 'github']" size="lg"></fa-icon>
    Report an Issue
  </a>
</div>

<div class="videoWrapper">
  <video appVideo>
    <source src="/intellij-ron-plugin/assets/demo-video.mp4" type="video/mp4">
  </video>
</div>
